export enum FunnelType {
  SALESFORCE = 'salesforce',
  THIRD_PARTY = 'thirdParty',
  RECORD_TYPE = 'recordType',
  HUBSPOT = 'hubspot',
}
